import React, { Component } from 'react';
import { bool, func, number, string } from 'prop-types';
import { utcShortDateString, numberWithCommas } from 'ps-components/lib/formatters';
import ArrowLink from 'ps-components/ArrowLink/ArrowLink';
import DataChicklet from 'ps-components/DataChicklet/DataChicklet';
import PricedEmployeesChart from 'ps-components/PricedEmployeesChart/PricedEmployeesChart';
import './MarketAnalysis.scss';

const BASE_SALARY_TOOLTIP_TEXT = 'Overall EE Base Salary as a Percentage of the Mkt Base 50th';
const TOTAL_CASH_TOOLTIP_TEXT = 'Overall EE Total Cash as a Percentage of the Mkt Total Cash 50th';

class MarketAnalysis extends Component {
  static propTypes = {
    baseMarketIndexCount: number,
    employeeDataEffectiveDate: string,
    employeesCount: number,
    employeesPricedSlotted: number,
    onTotalEmployeesClick: func,
    totalCashMarketIndexCount: number
  };

  constructor(props) {
    super(props);

    this.getDataString = this.getDataString.bind(this);
    this.getEffectiveDate = this.getEffectiveDate.bind(this);
  }

  getDataString(dataPoint) {
    const placeholder = '< 1';
    return dataPoint > 0 && dataPoint < 1 ? placeholder : dataPoint;
  }

  getEffectiveDate() {
    const { employeeDataEffectiveDate } = this.props;
    const asOfDate = new Date(employeeDataEffectiveDate);
    return utcShortDateString(asOfDate);
  }

  render() {
    const {
      baseMarketIndexCount,
      employeeDataEffectiveDate,
      employeesCount,
      employeesPricedSlotted,
      onTotalEmployeesClick,
      totalCashMarketIndexCount
    } = this.props;
    const asOfDateString = employeeDataEffectiveDate ? this.getEffectiveDate() : '';
    const baseMarketIndexCountString = this.getDataString(baseMarketIndexCount);
    const employeeCount = employeesCount ? numberWithCommas(employeesCount) : '';
    const employeesPricedSlottedString = this.getDataString(employeesPricedSlotted);
    const hasMarketData = baseMarketIndexCount >= 0;
    const totalCashMarketIndexCountString = this.getDataString(totalCashMarketIndexCount);

    return (
      <div className="market__analysis">
        <div className="market__analysis--title">Employee Analysis</div>
        <div className="market__analysis--details">
          <div className="market__data">
            <ArrowLink dataTestId="homeMarketEmployeeLink" onClick={onTotalEmployeesClick} title="Total Employees" />
            {hasMarketData && asOfDateString && (
              <div className="market__data--label" data-testid="homeMarketAsOfDate">
                As of {asOfDateString}
              </div>
            )}
            <div className="market__data--count" data-testid="homeMarketEmployeeCount">
              {employeeCount}
            </div>
          </div>
          {hasMarketData && <PricedEmployeesChart pricedEmployees={employeesPricedSlottedString} />}
          {hasMarketData && (
            <div className="market__analysis--chicklets">
              <div className="market__analysis--index">
                <i className="icon-chart-line" />
                <span className="market__index">Market Index</span>
              </div>
              <div className="chicklet__container">
                <DataChicklet
                  dataTestId="homeMarketBaseCount"
                  label="Base"
                  labelTooltip={BASE_SALARY_TOOLTIP_TEXT}
                  value={`${baseMarketIndexCountString}%`}
                />
                <div className="divider" />
                <DataChicklet
                  dataTestId="homeMarketCashCount"
                  label="Total Cash"
                  labelTooltip={TOTAL_CASH_TOOLTIP_TEXT}
                  value={`${totalCashMarketIndexCountString}%`}
                />
              </div>
            </div>
          )}
        </div>
      </div>
    );
  }
}

export default MarketAnalysis;
